module.exports = __webpack_public_path__ + "img/transparent-dark-blue.88b947a0.png";